import React, { useCallback } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  styled,
  Divider,
  Box,
} from '@mui/material';
import { useAuth } from '../contextProviders/authentication';

export const NavBar = () => {
  const { user, setUser } = useAuth();
  const handleLogout = useCallback(() => {
    setUser(undefined);
    localStorage.removeItem('user');
  }, [setUser]);

  return (
    <StyledAppBar position="static">
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <StyledTypography variant="h6">
          Vehicle Management System
        </StyledTypography>
        {user && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Typography>{user.username}</Typography>
            <StyledDivider orientation="vertical" flexItem />
            <StyledButton onClick={handleLogout}>Logout</StyledButton>
          </Box>
        )}
      </Toolbar>
    </StyledAppBar>
  );
};

const StyledAppBar = styled(AppBar)({
  backgroundColor: '#3d6865',
});

const StyledTypography = styled(Typography)({
  flexGrow: 1,
});

const StyledButton = styled(Button)({
  color: 'white',
});

const StyledDivider = styled(Divider)(({ theme }) => ({
  height: '28px',
  backgroundColor: 'white',
  margin: '0 10px',
  alignSelf: 'center',
}));
